import {createFileRoute} from '@tanstack/react-router';

import {CreateCategoryForm} from '@/features/Library/components/Category/CreateCategoryForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/categories/create')({
  component: CreateCategoryForm,
  beforeLoad: () => makeDocumentTitle('Create Category'),
});
